<div *ngIf="clientLoaded" class="app-ui-wrapper">
    <app-navigation-bar class="app-navigation-bar" [clientObject]="clientService.client">
    </app-navigation-bar>

    <div class="main-content">
        <router-outlet></router-outlet>
    </div>

    <app-footer *ngIf="!loader" class="app-footer" [clientObject]="clientService.client">
    </app-footer>

    <div *ngIf="loader">
        <mat-spinner mode="indeterminate" diameter="30"></mat-spinner>
    </div>

</div>